const Sections = {
  INITIAL: 'initial',
  LOADER: 'loader',
  HOME: 'home'
};

const SectionsURLs = {
  INITIAL: '/initial',
  LOADER: '/loader',
  HOME: '/'
};

export { Sections, SectionsURLs };
